const relColor = (r) => (r == null ? "#CFC8B8" : r >= 75 ? "#2F6B45" : r >= 50 ? "#2B4C6F" : r >= 30 ? "#9A6700" : "#9B2C2C");
const lbl = (i) => `${["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][i % 12]} ${Math.floor(i / 12)}`;

export function CareerGantt({ roles, gaps }) {
  if (!roles.length) return <p className="text-sm text-ink-muted">No dated roles found on the resume.</p>;
  const min = Math.min(...roles.map((r) => r.start), ...gaps.map((g) => g.start));
  const max = Math.max(...roles.map((r) => r.end), ...gaps.map((g) => g.end));
  const span = Math.max(1, max - min);
  const pos = (s, e) => ({ left: `${((s - min) / span) * 100}%`, width: `${Math.max(1.5, ((e - s) / span) * 100)}%` });
  const years = [];
  for (let y = Math.ceil(min / 12); y * 12 <= max; y += 1) years.push(y);
  return (
    <section className="panel space-y-3 p-5" data-tour="pt-career-gantt" data-testid="career-gantt">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h3 className="text-base font-semibold">Career timeline</h3>
        <div className="flex flex-wrap gap-3 text-[11px] text-ink-muted">
          {[["75+", 80], ["50–74", 60], ["30–49", 40], ["<30", 10]].map(([t, v]) => <span key={t} className="flex items-center gap-1"><i className="h-2.5 w-2.5 rounded-sm" style={{ background: relColor(v) }} />{t} relevance</span>)}
          <span className="flex items-center gap-1"><i className="tl-hatch h-2.5 w-4 rounded-sm border border-line" />Gap</span>
        </div>
      </div>
      <div className="relative space-y-2 pt-5">
        <div className="absolute inset-x-0 top-0 h-full">
          {years.map((y) => <div key={y} className="absolute top-0 h-full border-l border-dashed border-line" style={{ left: `${((y * 12 - min) / span) * 100}%` }}><span className="absolute -top-0.5 left-1 text-[10px] text-ink-muted">{y}</span></div>)}
        </div>
        {gaps.map((g) => <div key={g.from} className="tl-hatch absolute bottom-0 top-5 rounded border border-line/70 opacity-80" style={pos(g.start, g.end)} title={`Gap ${g.months} months`} data-testid={`gantt-gap-${g.from}`} />)}
        {[...roles].reverse().map((r) => (
          <div key={r.index} className="relative h-8" data-testid={`gantt-role-${r.index}`}>
            <div className="absolute flex h-full items-center overflow-hidden rounded-md px-2 text-[11px] font-medium text-white shadow-sm" style={{ ...pos(r.start, r.end), background: relColor(r.relevance) }}
              title={`${r.title} · ${r.company} · ${lbl(r.start)} – ${r.is_current ? "now" : lbl(r.end)} · relevance ${r.relevance ?? "n/a"}`}>
              <span className="truncate">{r.title} · {r.company}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export { relColor, lbl };
